import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Dialog Title")
const _hoisted_2 = { class: "flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_t = _resolveComponent("t")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    left: _withCtx(() => [
      _createVNode(_component_Icon, {
        name: "check",
        class: "bg-success mr-10",
        style: {"font-size":"20px","color":"white","border-radius":"20px"}
      })
    ]),
    title: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _hoisted_1
      ])
    ]),
    controls: _withCtx(() => [
      _renderSlot(_ctx.$slots, "controls", {}, () => [
        _createVNode(_component_Button, {
          class: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_t, {
              path: "notification_32",
              custom: ""
            }, {
              default: _withCtx(({td}) => [
                _createTextVNode(_toDisplayString(td || 'OK'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}